module.exports = __webpack_public_path__ + "media/images/indicators/estresse-496c9eac41aecfe27dec301cafb31c63.png";